(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('styledPageHeader', {
            templateUrl: 'app/components/styled-page-header/styled-page-header.html',
            controller: styledPageHeaderController,
            bindings: {
                name: '@',
                description: '@',
                isLarge: '<'
            }
        });

    /** @ngInject */
    function styledPageHeaderController() {
    }
})();
